/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_To_SquadInputs */

const th_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มเข้าทีม`)
};

const en_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to squad`)
};

const ja_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーに加える`)
};

const zh_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入阵容`)
};

const es_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir a la plantilla`)
};

const pt_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar ao elenco`)
};

const id_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan ke skuad`)
};

const fr_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter à l’effectif`)
};

const tl_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idagdag sa squad`)
};

const vi_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vào đội hình`)
};

const ko_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수단에 추가`)
};

const de_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Kader hinzufügen`)
};

const ru_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить в состав`)
};

const tr_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadroya ekle`)
};

const it_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi alla rosa`)
};

const pl_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj do składu`)
};

const uk_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додати до складу`)
};

const hi_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम में जोड़ें`)
};

const ar_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة إلى التشكيلة`)
};

const ms_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah ke skuad`)
};

const bn_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দলে যোগ করুন`)
};

const zh_tw2_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入名單`)
};

const zh_hk2_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入名單`)
};

const ur_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکواڈ میں شامل کریں`)
};

const fa_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افزودن به فهرست تیم`)
};

const sw_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeza kwenye kikosi`)
};

const nl_add_to_squad = /** @type {(inputs: Add_To_SquadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan selectie toevoegen`)
};

/**
* | output |
* | --- |
* | "Add to squad" |
*
* @param {Add_To_SquadInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const add_to_squad = /** @type {((inputs?: Add_To_SquadInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_To_SquadInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_add_to_squad(inputs)
	if (locale === "ja") return ja_add_to_squad(inputs)
	if (locale === "zh") return zh_add_to_squad(inputs)
	if (locale === "es") return es_add_to_squad(inputs)
	if (locale === "pt") return pt_add_to_squad(inputs)
	if (locale === "id") return id_add_to_squad(inputs)
	if (locale === "fr") return fr_add_to_squad(inputs)
	if (locale === "tl") return tl_add_to_squad(inputs)
	if (locale === "vi") return vi_add_to_squad(inputs)
	if (locale === "ko") return ko_add_to_squad(inputs)
	if (locale === "de") return de_add_to_squad(inputs)
	if (locale === "ru") return ru_add_to_squad(inputs)
	if (locale === "tr") return tr_add_to_squad(inputs)
	if (locale === "it") return it_add_to_squad(inputs)
	if (locale === "pl") return pl_add_to_squad(inputs)
	if (locale === "uk") return uk_add_to_squad(inputs)
	if (locale === "hi") return hi_add_to_squad(inputs)
	if (locale === "ar") return ar_add_to_squad(inputs)
	if (locale === "ms") return ms_add_to_squad(inputs)
	if (locale === "bn") return bn_add_to_squad(inputs)
	if (locale === "zh-TW") return zh_tw2_add_to_squad(inputs)
	if (locale === "zh-HK") return zh_hk2_add_to_squad(inputs)
	if (locale === "ur") return ur_add_to_squad(inputs)
	if (locale === "fa") return fa_add_to_squad(inputs)
	if (locale === "sw") return sw_add_to_squad(inputs)
	if (locale === "nl") return nl_add_to_squad(inputs)
	return en_add_to_squad(inputs)
});